import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TermanService } from 'src/app/services/terman.service';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-terman-factor',
  templateUrl: './create-terman-factor.component.html',
  styles: [
  ]
})
export class CreateTermanFactorComponent implements OnInit {

  public rankArray=[];

  public rank = {
    title:"",
    description:"",
    low:"",
    high:""
  }

  public termanFactorForm = this.fb.group({
    serie:[''],
    rank:[[{}]]
  })
  constructor(private fb:FormBuilder, private termanService:TermanService) {
    this.rank.title="";
   }

  ngOnInit(): void {
  }

  addRank(){
    if(this.rank.low<this.rank.high){
      var aux = this.rank;
      this.rankArray.push(aux);
      this.rank = {
        title:"",
        description:"",
        low:"",
        high:""
      }
    }

  }
  register(){
    this.termanFactorForm.get('rank').setValue(this.rankArray);
    this.termanService.createFactor(this.termanFactorForm.value).subscribe(
      resp=>{
        this.termanFactorForm.reset();
        this.rankArray=[];
        let timerInterval
        Swal.fire({
          title: 'Factor creado',
          html: '',
          timer: 1000,
          timerProgressBar: true,
          willOpen: () => {
            Swal.showLoading()
          },
          onClose: () => {
            clearInterval(timerInterval)
          }
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
            
          }
        })
      },
      err=>{
        console.log(err);
      }
    )
  }

  reset(){
    this.termanFactorForm.reset();
    this.rankArray=[];
    this.rank = {
      title:"",
      description:"",
      low:"",
      high:""
    };
  }

}
